import { isString } from 'lodash';

const validators = {
    required: function(value) {
        return !!value;
    },
    numeric: function(value) {
        return isFinite(value);
    },
    string: function(value) {
        return isString(value);
    },
};
export { validators };

export default {
    data() {
        return {
            errors: {},
        }
    },
    methods: {
        resetErrors() {
            this.errors = {};
        },
        /**
         * Validates a form based on the given fields
         *
         * @param {{}} rules
         * @param {{}} values
         *
         * @returns {boolean}
         */
        validate(rules, values) {
            let validated = true;

            // Loop through each list of rules, and run the validator functions against value with the same key in the
            // values' parameter.
            for(const key in rules) {
                // If a rule is against a value that doesn't exist then it can't be validated.
                // TODO: Should this assume it's null instead to allow for nullable rules?
                if(!Object.keys(values).includes(key)) {
                    this.errors[key] = true;
                    validated = false;
                    continue;
                }

                let valid = true;
                for (const rule of rules[key]) {
                    valid = rule(values[key]) && valid;
                }
                if(!valid) {
                    this.errors[key] = true;
                    validated = false;
                }
            }
            return validated;
        }
    }
}
